export const isAdmin = () => {
  let userDetail = localStorage.getItem("userDetails");
  if (userDetail !== undefined && userDetail !== null) {
    return JSON.parse(userDetail || "").isAdmin;
  } else {
    return null;
  }
};

export const isInvestigator = () => {
  let userDetail = localStorage.getItem("userDetails");
  if (userDetail !== undefined && userDetail !== null) {
    return JSON.parse(userDetail || "").isInvestigator;
  } else {
    return null;
  }
};

export const currentUserId = () => {
  let userDetail = localStorage.getItem("userDetails");
  if (userDetail !== undefined && userDetail !== null) {
    return JSON.parse(userDetail || "").userId;
  } else {
    return null;
  }
};

export const isUserType = () => {
  let userDetail = localStorage.getItem("userDetails");
  if (userDetail !== undefined && userDetail !== null) {
    return JSON.parse(userDetail || "").userType;
  } else {
    return null;
  }
};
export const isCounsellor = () => {
  let userDetail = localStorage.getItem("userDetails");
  if (userDetail !== undefined && userDetail !== null) {
    return JSON.parse(userDetail || "").IsCounsellor;
  } else {
    return null;
  }
};
export const isAccessToken = () => {
  let userDetail = localStorage.getItem("userDetails");
  if (userDetail !== undefined && userDetail !== null) {
    return JSON.parse(userDetail || "").accessToken;
  } else {
    return null;
  }
};
export const isSSO = () => {
  let isSSO = localStorage.getItem("isSSO");
  if (isSSO !== undefined && isSSO !== null) {
    return JSON.parse(isSSO || "").isSSO;
  } else {
    return null;
  }
};

export const isPermited = (module: any, modulePermission: any) => {
  let userPermission: any = localStorage.getItem("URP");
  let checkStore: any = localStorage.getItem("store");
  let checkStoreJson = JSON.parse(checkStore);
  let isUserPermited = false;

  if (checkStoreJson === true) {
    //console.log(userPermission,module,modulePermission,"userPermissionuserPermission")
    if (
      userPermission !== undefined &&
      userPermission !== null &&
      userPermission?.length !== null
    ) {
      //console.log(userPermission,"userPermissionuserPermission")
      let userPermissionArr = JSON.parse(userPermission);
      let i;
      let len = userPermissionArr?.length;
      for (i = 0; i < len; i++) {
        if (userPermissionArr[i]?.moduleId === module) {
          if (userPermissionArr[i]?.permission.lenght != 0) {
            let permisionsArr = userPermissionArr[i]?.permission.split(",");

            let j;
            let len = permisionsArr.length;
            for (j = 0; j < len; j++) {
              if (permisionsArr[j] == modulePermission) {
                return (isUserPermited = true);
                break;
              } else {
                isUserPermited = false;
              }
            }
            break; //first if break
          } else {
            isUserPermited = false;
          }
        }
        isUserPermited = false;
      }
    } else {
      isUserPermited = false;
    }
  }
  isUserPermited = false;

  return isUserPermited;
};
